// Module
var code = "<template>\n    <require from=\"./service-invoice-spagetti-products\"></require>\n    \n    <service-invoice-spagetti-products erp-system-id.bind=\"3\"></service-invoice-spagetti-products>\n</template>";
// Exports
export default code;